export default ['需要邮寄', '暂不邮寄', '需要邮寄（变更）'];